/**
 * @description: websocket方法封装
 */
export default class Socket {
    /**
     * @description: 构造函数
     * @param {*} params 构造函数参数
     */
    constructor(params) {
        window.WebSocket = window.WebSocket || window.MozWebSocket;
        if (!window.WebSocket) { // 检测浏览器支持
            console.error('错误: 浏览器不支持websocket');
            return;
        }
        this.websocket = null;
        this.reconnectTimes = 0; // 重连的次数
        this.isReconnect = true; // 是否开启重连模式
        this.params = params;
        this.socketInit(params);
    }

    /**
     * @description:              初始化websocket
     * @param {*} url             WebSocket请求的的URL
     * @param {*} onopenFun       open事件的回调函数
     * @param {*} onMessage       message事件的回调函数
     * @param {*} oncloseFun      close事件的回调函数
     * @param {*} onerrorFun      error事件的回调函数
     * @param {*} timer           心跳周期 若为空或0则不启用
     * @param {*} maxReconnectNum 重连的最大次数
     */
    socketInit({url, onopenFun, onMessage, oncloseFun, onerrorFun, timer = 8000, maxReconnectNum = 3}) {
        if (!url) {
            return;
        }
        try {
            this.websocket = new WebSocket(url);
            // 连接成功之后的回调函数
            this.websocket.onopen = e => {
                if (timer > 0) {
                    this.heartbeat(timer);
                }
                this.reconnectTimes = 0;
                if (typeof onopenFun === 'function') {
                    onopenFun(e);
                }
            };
            // 接收到服务器消息的回调函数
            this.websocket.onmessage = message => {
                this.handleResCodeStrategy(message, oncloseFun, onMessage);
            };
            // 连接关闭之后的回调函数
            this.websocket.onclose = e => {
                // 需要重新连接
                if (this.isReconnect) {
                    // 超过重连次数
                    if (this.reconnectTimes >= maxReconnectNum) {
                        return;
                    }

                    // 记录重连次数
                    this.reconnectTimes++;
                    this.reconnectFun();
                }
            };
            // 连接失败后的回调函数
            this.websocket.onerror = e => {
                console.log('连接异常', e);
                if (typeof onerrorFun === 'function') {
                    onerrorFun(e);
                }
            };

            // 监听窗口事件，当窗口关闭时，主动断开websocket连接，防止连接没断开就关闭窗口，server端报错
            window.onbeforeunload = () => {
                this.websocket.close();
            };

        }
        catch (e) {
            console.log('catch error', e);
        }
    }

    /**
     * @description: 发送消息
     * @param {*} message
     * @return {*}
     */
    send(message) {
        /**
            CONNECTING：值为0，表示正在连接。
            OPEN：值为1，表示连接成功，可以通信了。
            CLOSING：值为2，表示连接正在关闭。
            CLOSED：值为3，表示连接已经关闭，或者打开连接失败。
        */
        if (!this.websocket || this.websocket.readyState !== 1) {
            console.log('请确认websocket是否连接成功，是否可以正常通信');
            return;
        }
        this.websocket.send(JSON.stringify(message));
    }

    /**
     * @description: 手动关闭socket
     * @return {*}
     */
    close() {
        console.log('主动断开连接');
        this.heartInterval && clearInterval(this.heartInterval);
        this.reconnectTimeout && clearTimeout(this.reconnectTimeout);
        if (!this.websocket) {
            console.log('websocket 不可用');
            return;
        }
        this.isReconnect = false;
        this.websocket.close();
    }

    /**
     * @description: 心跳机制，周期性发送ping
     * @param {*} timer
     * @return {*}
     */
    heartbeat(timer) {
        console.log('socket', 'ping');
        if (this.heartInterval) {
            clearInterval(this.heartInterval);
        }

        this.heartInterval = window.setInterval(() => {
            // 请求类型 cmd 3 发送心跳包
            this.send({cmd: 3});
        }, timer);
    }

    /**
     * @description: 断线重连
     * @return {*}
     */
    reconnectFun() {
        if (this.lockReconnect) {
            return;
        }

        this.lockReconnect = true;
        this.reconnectTimeout && clearTimeout(this.reconnectTimeout);
        this.reconnectTimeout = window.setTimeout(() => {

            this.socketInit(this.params);
            this.lockReconnect = false;

        }, 5000);
    }
    /**
     * @description: 处理消息返回值
     * @return {*}
     */
    handleResCodeStrategy(message, closeCallback, messageCallback) {
        try {
            const response = JSON.parse(message.data);
            // 服务端心跳响应
            if (response.cmd === 4) {
                return;
            }
            messageCallback(response);
            // 9:客服主动关闭请求；// 10: 用户超时未反馈关闭请求
            if (response.cmd === 9 || response.cmd === 10) {
                this.websocket.close();
                closeCallback && closeCallback(response);
            }
            // 其他情况
        }
        catch (e) {
            console.log(e);
        }
    }
}
